import { METHOD_TYPES } from 'constants/index'
import axiosInstance from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'

export const placeBetPlinkoGameService = (data) => {
  return axiosInstance(METHOD_TYPES.post, 'plinko-game/place-bet', data, {
    server: microServices.USER_URL
  })
}

export const getMyBetsPlinkoService = (params) => {
  return axiosInstance(METHOD_TYPES.get, 'plinko-game/my-bets', {}, {
    params,
    server: microServices.USER_URL
  })
}

export const postLightningBoardDetailsService = () => {
  return axiosInstance(METHOD_TYPES.post, 'plinko-game/lightning-board-details', {}, {
    server: microServices.USER_URL
  })
}
